import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { Geoutil } from 'src/app/shared/geoutil';
import { Google_map } from 'src/app/shared/google_map';
import { Gps } from 'src/app/shared/gps';
@Component({
  selector: 'app-simdebug',
  templateUrl: './simdebug.component.html',
  styleUrls: ['./simdebug.component.css']
})
export class SimdebugComponent extends BaseComponent implements OnInit {
  @ViewChild('pagemap', { static: true }) mapElement: any = {}
  scenario: any = {}
  scenariolayout: any = {contours: []}
  scenarioid = "0"
  google_map: Google_map
  gps: Gps
  counter = 0
  currentContourId = 0;
  debug = false
  distance = 0
  nInterval: any
  gpslog: any = {id: 0, organizationid: 1, latitude: 0, longitude: 0,accuracy: 0, phoneinfo:"1",heigth: 0}
  phoneinfo = ""
  scenariosensors: any = []
  constructor(injector: Injector) { super(injector) }

  ngOnInit(): void {
    this.gps = new Gps();
  }

  async getData() {
    this.scenario = await this.db.get("scenario", "getscenario", { id: this.scenarioid });
    this.scenariosensors = await this.db.get("scenariosensor","getscenariosensorsbyscen",{scenarioid: this.scenarioid})
    this.scenariosensors.forEach((ss:any) =>{
      ss.reading = 0
    });
    if (this.scenario.geometryJson.length > 5) {
      this.scenariolayout = JSON.parse(this.scenario.geometryJson);
      this.showMap();
    }

  }
  async start() {
    this.gpslog.phoneinfo = this.randomString(6)
    this.gpslog.scenarioid = this.scenarioid
    this.loader.show()
    await this.getData()
    if (this.debug) {
      this.updateDebugLocations()
    } else {
      this.gps.updateLocation(this.updateLocationCallback.bind(this)); //callbacks need a bind
    }
    this.loader.hide()
  }

  showMap() {
    this.google_map = new Google_map()
    let latlng = this.scenariolayout.center
    this.google_map.init(this.mapElement.nativeElement, latlng, 15)
    this.google_map.setMarker(latlng, "Center");
    this.scenariolayout.contours.forEach((p: any, i: number) => {
      let color = this.scenariolayout.contourdefinitions[i].color;
      this.google_map.addPolygon(p, color)
    })
  }

  async updateLocationCallback(latlng: any) {

    

    this.counter += 1
    this.google_map.addCircle(latlng, 2, "#0909FF");
    this.distance = Geoutil.getDistance(this.scenariolayout.center, latlng);
    this.currentContourId = this.scenariolayout.contours.length - 1;
    for (let i = this.scenariolayout.contours.length - 1; i >= 0; i--) {
      let isInPoly = Geoutil.pointInPolygon(this.scenariolayout.contours[i], latlng);
      if (isInPoly) {
        this.currentContourId = i
      }
    }

    this.gpslog.latitude = latlng.lat
    this.gpslog.longitude = latlng.lng
    this.gpslog.height = this.scenariolayout.contourdefinitions[this.currentContourId ].exposure
    this.scenariosensors.forEach((ss:any) =>{
      ss.reading = this.gpslog.height * ss.gpsMaxReading / 100
    });
    await this.db.post("gpslog","postgpslog",this.gpslog)
    //this.alert.success("Counter: " + this.counter + ", Distance " + this.distance.toFixed(1) + " meter; In Poly: " + this.currentContourId + "; Value: " + this.scenariolayout.contourdefinitions[this.currentContourId ].exposure);
  }

  updateDebugLocations() {
    let latlng = { lat: this.scenariolayout.center.lat, lng: this.scenariolayout.center.lng }
    if (!this.nInterval) {
      this.nInterval = setInterval(() => {
        this.updateLocationCallback(latlng) //Call the same function as the gps
        latlng = Geoutil.getDifLAtLong(latlng, 5, 1) //move east
      }, 1000);
    }

  }

  stop(){
    clearInterval(this.nInterval)
  }

}
